import { createContext } from "react";
import { noop } from "@common/helpers/function";
import { CheckForImporterErrorsOptions } from "@api/financialDocument.api";
import {
    AccrualDocumentImporterMode,
    getAccrualDocumentImporterConfig,
} from "./accrualDocumentImporter.lib";
import {
    AccrualImporterDocumentRow,
    AccrualImporterSort,
} from "./accrualImporter.types";

interface AccrualImporterContextValue {
    mode: AccrualDocumentImporterMode;
    importerQueue: string;
    documentRows: AccrualImporterDocumentRow[];
    sortedRows: AccrualImporterDocumentRow[];
    sort: AccrualImporterSort | undefined;
    previewedRowId?: string;
    previewedExtractionId?: string;
    isRefreshEnabled: boolean;
    readyToImportLabel: string;
    setSort: (sort: AccrualImporterSort | undefined) => void;
    setPreviewedRowId: (
        rowId: string | undefined,
        extractionId?: string,
    ) => void;
    upsertDocumentRow: (documentRow: AccrualImporterDocumentRow) => void;
    updateDocumentRow: (
        id: string,
        documentRow: Partial<Omit<AccrualImporterDocumentRow, "id">>,
    ) => void;
    removeDocumentRow: (documentRow: AccrualImporterDocumentRow) => void;
    revalidateDocument: (options: CheckForImporterErrorsOptions) => void;
    setRefreshSuppressed: () => void;
    setRefreshUnsuppressed: () => void;
}

export const AccrualImporterContext =
    createContext<AccrualImporterContextValue>({
        mode: "invoices",
        importerQueue:
            getAccrualDocumentImporterConfig("invoices").importerQueue,
        documentRows: [],
        sortedRows: [],
        sort: undefined,
        previewedRowId: undefined,
        previewedExtractionId: undefined,
        isRefreshEnabled: false,
        readyToImportLabel: "",
        setSort: noop,
        setPreviewedRowId: noop,
        upsertDocumentRow: noop,
        updateDocumentRow: noop,
        removeDocumentRow: noop,
        revalidateDocument: noop,
        setRefreshSuppressed: noop,
        setRefreshUnsuppressed: noop,
    });
